import { CKEditor as OriginalCKEditor } from "ckeditor4-react";
import { compose, withHooks } from "enhancers";
import { Box, InputLabel } from "@material-ui/core";
import Typography from "./Typography";
import { AppColor } from "theme/app-color";
import { useEffect } from "react";
import { get } from "lodash";

const CKEditorComponent = ({
  initData,
  handleChange,
  name,
  label,
  required,
  isError,
  error,
}: any) => (
  <Box>
    {label && (
      <InputLabel shrink htmlFor={name}>
        <Typography variant="Header/24" color={AppColor["Text/Primary Text"]}>
          {label}
          <span style={{ color: AppColor["SecondaryText/Danger"] }}>
            {required && " *"}
          </span>
        </Typography>
      </InputLabel>
    )}
    <Box mt={1}>
      <OriginalCKEditor
        initData={initData}
        name={name}
        editorUrl="https://cdn.ckeditor.com/4.22.1/standard/ckeditor.js"
        onChange={(event) => {
          handleChange({
            target: { name, value: event.editor.getData() },
          });
        }}
      />
      {isError && (
        <Box mt={1}>
          <Typography
            variant="Helper/12"
            color={AppColor["SecondaryText/Danger"]}
          >
            {error}
          </Typography>
        </Box>
      )}
    </Box>
  </Box>
);

const enhancer = compose(
  withHooks((props: any, hook: any) => {
    const { useCallback, useMemo } = hook;
    const { form, field, label, required } = props;

    const name = useMemo(() => field.name, [field]);

    const handleChange = useCallback(
      (e: any) => {
        form.handleChange(e);
        form.setFieldTouched(name, true);
      },
      [form, name]
    );

    const initData = useMemo(() => form.values[name], [form, name]);

    const touched = get(props.form.touched, props.field.name);
    const error = get(props.form.errors, props.field.name);

    const isError = useMemo(() => {
      return touched && !!error;
    }, [touched, error]);

    return {
      initData,
      name,
      handleChange,
      label,
      required,
      isError,
      error,
    };
  })
);

export const CKEditor = enhancer(CKEditorComponent);
